import { BankIcon } from './BankIcon';

/**
 * author: Google
 * id FE08919F-CFFC-4A25-994C-CEDEB299908B
 * name bank
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bank.svg
 * tags
 * - Banking 
 * - Places 
 */
export const AccountBalanceIcon = BankIcon;
export default AccountBalanceIcon